import { AbstractControl, FormGroup } from '@angular/forms';

export const getFormControl = (
    form: FormGroup | null | undefined,
    controlName: string
): AbstractControl | null => {
    return form ? form.get(controlName) : null;
};
